(function () {
  "use strict";

  XlsUploadCtrl.$inject = ['$scope', 'mtypes', 'accountFeatures', 'fileUpload', 'excelResource'];
  angular
    .module('trainerWebApp.controllers')
    .controller('XlsUploadCtrl', XlsUploadCtrl);

  function XlsUploadCtrl($scope, mtypes, accountFeatures, fileUpload, excelResource) {
    if ($scope.isUsernameEnabled)
      $scope.xlsTemplatePath = mfConfig.usernameXlsTemplatePath;
    else if (_.contains(accountFeatures.features, mtypes.featureEntry.multipleCustomFields))
      $scope.xlsTemplatePath = mfConfig.proTierXlsTemplatePath;
    else
      $scope.xlsTemplatePath = mfConfig.basicXlsTemplatePath;

    $scope.uploadParams = {
      accept: ['.xls', '.xlsx'],
      transformations: {},
      fromSources: ['local_file_system', 'dropbox', 'box'],
      maxSize: 10 * 1024 * 1024
    };

    $scope.uploadFileButton = function() {
      fileUpload.pick($scope.uploadParams).then($scope.processFileUpload);
    };

    $scope.processFileUpload = function(outcome) {
      if (outcome.success) {
        $scope.uploading = true;
        excelResource.getExcelData(outcome.data.fileUrl, function (result) {
          $scope.uploading = false;
          $scope.xlsDataReady(result);
        }, function () {
          $scope.uploading = false; });
      }
    };
  }

})();
